import Logo from "@/components/site/Logo";

const cols = [
  {
    title: "Capabilities",
    links: [
      "Executive & Convoy Security",
      "Life Support & Logistics",
      "Industrial Supply & Trade",
      "Engineering & EPC",
      "Aviation Ground Logistics",
      "Ports & Heavy Handling",
    ],
  },
  {
    title: "Group",
    links: ["About Mends", "Global Reach", "Contact"],
  },
];

export default function Footer() {
  return (
    <footer
      className="relative border-t border-navy-border bg-navy-base"
      data-testid="site-footer"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size={44} />
            <p className="mt-8 text-white/50 max-w-sm text-[14.5px] leading-[1.8]">
              A US-based partner for organizations operating where scrutiny is high
              and margins for error are low.
            </p>
            <div className="mt-8 flex flex-col gap-2">
              <a
                href="tel:+12482693506"
                className="text-white/70 hover:text-gold transition-colors font-display text-lg"
                data-testid="footer-phone"
              >
                (248) 269-3506
              </a>
              <a
                href="mailto:mendsinternationalgroup@gmail.com"
                className="text-white/70 hover:text-gold transition-colors font-sans text-sm break-all"
                data-testid="footer-email"
              >
                mendsinternationalgroup@gmail.com
              </a>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-3">
              <div className="overline mb-6">{c.title}</div>
              <ul className="flex flex-col gap-3">
                {c.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      className="text-white/60 hover:text-white text-sm transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1 flex md:justify-end">
            <a
              href="/admin/login"
              className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/30 hover:text-gold transition-colors"
              data-testid="footer-admin"
            >
              Admin
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-navy-border flex flex-col md:flex-row justify-between gap-4 font-mono text-[11px] tracking-[0.2em] uppercase text-white/40">
          <div>© {new Date().getFullYear()} Mends International Group · United States</div>
          <div>Middle East New Direction Solutions</div>
        </div>
      </div>
    </footer>
  );
}
